import { IQuanLyHocPhanSelectRequest } from "../../model/request/quyet-dinh/IQuanLyHocPhanSelectRequest";
import { ISMT_QuyetDinh_QuanLyHocPhan_Vm } from "../../model/respone/quyet-dinh/quan-ly-hoc-phan/ISMT_QuyetDinh_QuanLyHocPhan_Vm";
import { apiClient } from "../apiClient";
export const QUAN_LY_HOC_PHAN_ENDPOINT = "quan-ly-hoc-phan";
export const quanLyHocPhanApi = {
  SelectAll: () => apiClient.get(`${QUAN_LY_HOC_PHAN_ENDPOINT}`),
  SelectVm: (payload: IQuanLyHocPhanSelectRequest) =>
    apiClient.post(`${QUAN_LY_HOC_PHAN_ENDPOINT}/select-vm`, payload),
  Insert: (payload: ISMT_QuyetDinh_QuanLyHocPhan_Vm) =>
    apiClient.post(`${QUAN_LY_HOC_PHAN_ENDPOINT}`, payload),
  Update: (payload: ISMT_QuyetDinh_QuanLyHocPhan_Vm) =>
    apiClient.put(`${QUAN_LY_HOC_PHAN_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${QUAN_LY_HOC_PHAN_ENDPOINT}/${id}`),
  SelectMonPhanCong: (loai_quyet_dinh: number, id_cb: string) =>
    apiClient.get(
      `${QUAN_LY_HOC_PHAN_ENDPOINT}/select-mon-phan-cong/${loai_quyet_dinh}/${id_cb}`
    ),
};
